// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"aa17509c","239":"7297edea","263":"8c1521cd","318":"bed99070","455":"285cc125","464":"afbf105f","533":"c103b776","879":"3c344974","991":"48d13588"}[chunkId] + ".chunk.js";
};